if (!customElements.get('country-province-selector')) {
  class CountryProvinceSelector extends HTMLElement {
    constructor() {
      super();
      this.countryEl = this.querySelector('.js-country-select');
      this.provinceEl = this.querySelector('.js-province-select');
      this.provinceContainer = this.querySelector('.js-province-container');
      this.init();
    }

    init() {
      CountryProvinceSelector.setSelectedOption(this.countryEl, this.countryEl.dataset.default);

      const countrySelect = document.querySelector('select[name="billing_country"]');

      if (countrySelect) {
        const countryCodeMapping = {
                "United States": "US",
                "Afghanistan": "AF",
                "Åland Islands":"AX",
                "Anguilla":"AI",
                "Albania": "AL",
                "Algeria": "DZ",
                "Algérie": "DZ",
                "Andorra": "AD",
                "Angola": "AO",
                "Antigua And Barbuda": "AG",
                "Argentina": "AR",
                "Aruba": "AW",
                "Armenia": "AM",
                "Australia": "AU",
                "Austria": "AT",
                "Azerbaijan": "AZ",
                "Bermuda": "BM",
                "Bermudes": "BM",
                "Bosnia And Herzegovina": "BA",
                "British Indian Ocean Territory": "IO",
                "Bahamas": "BS",
                "Bahrain": "BH",
                "Bangladesh": "BD",
                "Barbados": "BB",
                "Belarus": "BY",
                "Belgium": "BE",
                "Belize": "BZ",
                "Benin": "BJ",
                "Bhutan": "BT",
                "Bhoutan": "BT",
                "Bolivia": "BO",
                "Bosnia and Herzegovina": "BA",
                "Botswana": "BW",
                "Brazil": "BR",
                "Brésil": "BR",
                "Brunei": "BN",
                "Bulgaria": "BG",
                "Burkina Faso": "BF",
                "Burundi": "BI",
                "Cape Verde": "CV",
                "Cap-Vert": "CV",
                "Cayman Islands": "KY",
                "Cambodia": "KH",
                "Cameroon": "CM",
                "Republic of Cameroon": "CM",
                "Canada": "CA",
                "Central African Republic": "CF",
                "Chad": "TD",
                "Chile": "CL",
                "Chili": "CL",
                "China": "CN",
                "Chine": "CN",
                "Colombia": "CO",
                "Comoros": "KM",
                "Comores": "KM",  
                "Christmas Island": "CX",
                "Congo (Congo-Brazzaville)": "CG",
                "Cocos (Keeling) Islands": "CC",
                "Congo": "CG",
                "Congo": "Congo-Brazzaville",
                "Congo, The Democratic Republic Of The": "CD",
                "South Georgia And The South Sandwich Islands": "GS",
                "Ascension Island": "AC",
                "Palestinian Territory, Occupied": "PS",
                "St. Vincent": "VC",
                "Saint Martin": "MF",
                "Saint Kitts And Nevis": "KN",
                "Caribbean Netherlands": "BQ",
                "Moldova, Republic of": "MD",
                "Libyan Arab Jamahiriya": "LY",
                "Lao People's Democratic Republic": "LA",
                "Aland Islands": "AX",
                "Guinea Bissau": "GW",
                "Timor Leste": "TL", 
                "Kongo-Kinshasa": "CD",
                "Costa Rica": "CR",
                "Croatia": "HR",
                "Cuba": "CU",
                "Cook Islands": "CK",
                "Îles Cook": "CK",
                "Curaçao":"CW",
                "Côte d'Ivoire":"CI",
                "Côte d’Ivoire":"CI", 
                "Cyprus": "CY",
                "Chypre": "CY",
                "Czechia (Czech Republic)": "CZ",
                "Denmark": "DK",
                "Djibouti": "DJ",
                "Dominica": "DM",
                "Dominican Republic": "DO",
                "Ecuador": "EC",
                "Egypt": "EG",
                "El Salvador": "SV",
                "Equatorial Guinea": "GQ",
                "Eritrea": "ER",
                "Estonia": "EE",
                "Eswatini": "SZ",
                "Ethiopia": "ET",
                "Fiji": "FJ",
                "Falkland Islands (Malvinas)": "FK",
                "Faroe Islands": "FO",
                "Îles Féroé": "FO",
                "Finland": "FI",
                "France": "FR",
                "French Guiana": "GF",
                "French Polynesia": "PF",
                "French Southern Territories": "TF",
                "Gibraltar": "GI",
                "Greenland": "GL",
                "Groenland": "GL",
                "Guadeloupe": "GP",
                "Guernsey": "GG",
                "Gabon": "GA",
                "Gambia": "GM",
                "Georgia": "GE",
                "Germany": "DE",
                "Allemagne": "DE",
                "Ghana": "GH",
                "Greece": "GR",
                "Grenada": "GD",
                "Guatemala": "GT",
                "Guinea": "GN",
                "Guinea-Bissau": "GW",
                "Guyana": "GY",
                "Haiti": "HT",
                "Holy See (Vatican City State)": "VA",
                "État de la Cité du Vatican": "VA",
                "Honduras": "HN",
                "Hungary": "HU",
                "Iceland": "IS",
                "India": "IN",
                "Indonesia": "ID",
                "Isle Of Man": "IM",
                "Île de Man": "IM",
                "Jersey": "JE",
                "Iran": "IR",
                "Iraq": "IQ",
                "Ireland": "IE",
                "Israel": "IL",
                "Italy": "IT",
                "Italie": "IT",
                "Jamaica": "JM",
                "Jamaïque": "JM", 
                "Japan": "JP",
                "Japon": "JP",
                "Jordan": "JO",
                "Kazakhstan": "KZ",
                "Kenya": "KE",
                "Kiribati": "KI",
                "North Korea": "KP",
                "South Korea": "KR",
                "Kuwait": "KW",
                "Kyrgyzstan": "KG",
                "Kosovo": "XK",  
                "Laos": "LA",
                "Latvia": "LV",
                "Lebanon": "LB",
                "Lesotho": "LS",
                "Liberia": "LR",
                "Libya": "LY",
                "Liechtenstein": "LI",
                "Lithuania": "LT",
                "Luxembourg": "LU",
                "Madagascar": "MG",
                "Malawi": "MW",
                "Martinique": "MQ", 
                "Malaysia": "MY",
                "Maldives": "MV",
                "Malediven": "MV", 
                "Macao":"MO",
                "Mayotte": "YT",
                "Montserrat": "MS",
                "Mali": "ML",
                "Malta": "MT",
                "Marshall Islands": "MH",
                "Mauritania": "MR",
                "Mauritius": "MU",
                "Mexico": "MX",
                "Micronesia": "FM",
                "Moldova": "MD",
                "Monaco": "MC",
                "Mongolia": "MN",
                "Montenegro": "ME",
                "Morocco": "MA",
                "Mozambique": "MZ",
                "Myanmar (Burma)": "MM",
                "Namibia": "NA",
                "Nauru": "NR",
                "Nepal": "NP",
                "New Caledonia": "NC",
                "Niue":"NU",
                "Norfolk Island":"NF",  
                "Netherlands": "NL",
                "New Zealand": "NZ",
                "Nicaragua": "NI",
                "Niger": "NE",
                "Nigeria": "NG",
                "North Macedonia": "MK",
                "Norway": "NO",
                "Oman": "OM",
                "Pakistan": "PK",
                "Pitcairn": "PN",
                "Îles Pitcairn": "PN", 
                "Palau": "PW",
                "Palestine State": "PS",
                "Panama": "PA",
                "Papua New Guinea": "PG",
                "Paraguay": "PY",
                "Peru": "PE",
                "Philippines": "PH",
                "Poland": "PL",
                "Portugal": "PT",
                "Qatar": "QA",
                "Romania": "RO",
                "Reunion": "RE",
                "Russia": "RU",
                "Rwanda": "RW",
                "Saint Kitts and Nevis": "KN",
                "Saint Lucia": "LC",
                "Saint Vincent and the Grenadines": "VC",
                "Saint Pierre And Miquelon": "PM",
                "Samoa": "WS",
                "Svalbard And Jan Mayen": "SJ",
                "San Marino": "SM",
                "Sao Tome And Principe": "ST",
                "Saudi Arabia": "SA",
                "Senegal": "SN",
                "Serbia": "RS",
                "Seychelles": "SC",
                "Sierra Leone": "SL",
                "Singapore": "SG",
                "Slovakia": "SK",
                "Sint Maarten": "SX",
                "Slovenia": "SI",
                "Saint Barthélemy": "BL",
                "Saint Helena": "SH",
                "Solomon Islands": "SB",
                "Îles Salomon": "SB",
                "Somalia": "SO",
                "South Africa": "ZA",
                "South Sudan": "SS",
                "Spain": "ES",
                "Sri Lanka": "LK",
                "Sudan": "SD",
                "Suriname": "SR",
                "Sweden": "SE",
                "Switzerland": "CH",
                "Syria": "SY",
                "Tajikistan": "TJ",
                "Taiwan": "TW",
                "Tokelau": "TK",
                "Tanzania": "TZ",
                "Thailand": "TH",
                "Timor-Leste": "TL",
                "Togo": "TG",
                "Tonga": "TO",
                "Trinidad and Tobago": "TT",
                "Tristan da Cunha": "SH",
                "Tunisia": "TN",
                "Turkey": "TR",
                "Turks and Caicos Islands": "TC",
                "Îles Turques-et-Caïques": "TC",
                "Turkmenistan": "TM",
                "Tuvalu": "TV",
                "Uganda": "UG",
                "United States Minor Outlying Islands": "UM",
                "Ukraine": "UA",
                "United Arab Emirates": "AE",
                "United Kingdom": "GB",
                "Uruguay": "UY",
                "Uzbekistan": "UZ",
                "Vanuatu": "VU",
                "Venezuela": "VE",
                "Vietnam": "VN",
                "Virgin Islands, British": "VG",
                "Wallis And Futuna":"WF",
                "Western Sahara": "EH",
                "Yemen": "YE",
                "Zambia": "ZM",
                "Zimbabwe": "ZW",
                "Ålandinseln": "AX",
                "Anguilla": "AI",
                "Albanien": "AL",
                "Algerien": "DZ",
                "Andorra": "AD",
                "Andorre": "AD",
                "Angola": "AO",
                "Antigua und Barbuda": "AG",
                "Argentinien": "AR",
                "Aruba": "AW",
                "Armenien": "AM",
                "Australien": "AU",
                "Österreich": "AT",
                "Aserbaidschan": "AZ",
                "Bermuda": "BM",
                "Bosnien und Herzegowina": "BA",
                "Britisches Territorium im Indischen Ozean": "IO",
                "Bahamas": "BS",
                "Bahrain": "BH",
                "Bangladesch": "BD",
                "Barbados": "BB",
                "Weißrussland": "BY",
                "Belgien": "BE",
                "Belize": "BZ",
                "Benin": "BJ",
                "Bhutan": "BT",
                "Bolivien": "BO",
                "Botswana": "BW",
                "Brasilien": "BR",
                "Brunei": "BN",
                "Bulgarien": "BG",
                "Burkina Faso": "BF",
                "Burundi": "BI",
                "Kap Verde": "CV",
                "Kaimaninseln": "KY",
                "Kambodscha": "KH",
                "Kamerun": "CM",
                "Kanada": "CA",
                "Zentralafrikanische Republik": "CF",
                "Tschad": "TD",
                "Chile": "CL",
                "China": "CN",
                "Kolumbien": "CO",
                "Komoren": "KM",
                "Weihnachtsinsel": "CX",
                "Kokosinseln": "CC",
                "Kongo (Brazzaville)": "CG",
                "Kongo (Kinshasa)": "CD",
                "Costa Rica": "CR",
                "Kroatien": "HR",
                "Kuba": "CU",
                "Cookinseln": "CK",
                "Curaçao": "CW",
                "Elfenbeinküste": "CI",
                "Zypern": "CY",
                "Tschechien": "CZ",
                "Dänemark": "DK",
                "Dschibuti": "DJ",
                "Dominica": "DM",
                "Dominikanische Republik": "DO",
                "Ecuador": "EC",
                "Ägypten": "EG",
                "El Salvador": "SV",
                "Äquatorialguinea": "GQ",
                "Eritrea": "ER",
                "Estland": "EE",
                "Eswatini": "SZ",
                "Äthiopien": "ET",
                "Fidschi": "FJ",
                "Falklandinseln": "FK",
                "Färöer": "FO",
                "Finnland": "FI",
                "Frankreich": "FR",
                "Französisch-Guayana": "GF",
                "Französisch-Polynesien": "PF",
                "Französische Süd- und Antarktisgebiete": "TF",
                "Gibraltar": "GI",
                "Grönland": "GL",
                "Guadeloupe": "GP",
                "Guernsey": "GG",
                "Guernesey": "GG",
                "Gabun": "GA",
                "Gambia": "GM",
                "Georgien": "GE",
                "Deutschland": "DE",
                "Ghana": "GH",
                "Griechenland": "GR",
                "Grenada": "GD",
                "Guatemala": "GT",
                "Guinea": "GN",
                "Guinée": "GN",
                "Guinea-Bissau": "GW",
                "Guyana": "GY",
                "Haiti": "HT",
                "Heard- und McDonaldinseln": "HM",
                "Honduras": "HN",
                "Ungarn": "HU",
                "Island": "IS",
                "Indien": "IN",
                "Indonesien": "ID",
                "Irak": "IQ",
                "Irland": "IE",
                "Israel": "IL",
                "Italien": "IT",
                "Jamaika": "JM",
                "Japan": "JP",
                "Jordanien": "JO",
                "Kasachstan": "KZ",
                "Kenia": "KE",
                "Kiribati": "KI",
                "Nordkorea": "KP",
                "Südkorea": "KR",
                "Kuwait": "KW",
                "Kirgisistan": "KG",
                "Laos": "LA",
                "Lettland": "LV",
                "Libanon": "LB",
                "Lesotho": "LS",
                "Liberia": "LR",
                "Libyen": "LY",
                "Liechtenstein": "LI",
                "Litauen": "LT",
                "Luxemburg": "LU",
                "Madagaskar": "MG",
                "Malawi": "MW",
                "Malaysia": "MY",
                "Maldiven": "MV",
                "Macao": "MO",
                "Mayotte": "YT",
                "Montserrat": "MS",
                "Mali": "ML",
                "Malta": "MT",
                "Marshallinseln": "MH",
                "Mauretanien": "MR",
                "Mauritius": "MU",
                "Mexiko": "MX",
                "Mikronesien": "FM",
                "Moldawien": "MD",
                "Monaco": "MC",
                "Mongolei": "MN",
                "Montenegro": "ME",
                "Marokko": "MA",
                "Mosambik": "MZ",
                "Myanmar": "MM",
                "Namibia": "NA",
                "Nauru": "NR",
                "Nepal": "NP",
                "Neukaledonien": "NC",
                "Niue": "NU",
                "Norfolkinsel": "NF",
                "Niederlande": "NL",
                "Neuseeland": "NZ",
                "Nicaragua": "NI",
                "Niger": "NE",
                "Nigeria": "NG",
                "Nordmazedonien": "MK",
                "Norwegen": "NO",
                "Oman": "OM",
                "Pakistan": "PK",
                "Pitcairninseln": "PN",
                "Palau": "PW",
                "Palästina": "PS",
                "Panama": "PA",
                "Papua-Neuguinea": "PG",
                "Paraguay": "PY",
                "Peru": "PE",
                "Philippinen": "PH",
                "Polen": "PL",
                "Portugal": "PT",
                "Katar": "QA",
                "Rumänien": "RO",
                "Réunion": "RE",
                "Russland": "RU",
                "Ruanda": "RW",
                "St. Kitts und Nevis": "KN",
                "St. Lucia": "LC",
                "St. Vincent und die Grenadinen": "VC",
                "St. Pierre und Miquelon": "PM",
                "Samoa": "WS",
                "Svalbard und Jan Mayen": "SJ",
                "San Marino": "SM",
                "São Tomé und Príncipe": "ST",
                "Saudi-Arabien": "SA",
                "Senegal": "SN",
                "Serbien": "RS",
                "Seychellen": "SC",
                "Sierra Leone": "SL",
                "Singapur": "SG",
                "Slowakei": "SK",
                "Sint Maarten": "SX",
                "Slowenien": "SI",
                "St. Barthélemy": "BL",
                "St. Helena": "SH",
                "Salomonen": "SB",
                "Somalia": "SO",
                "Südafrika": "ZA",
                "Südsudan": "SS",
                "Spanien": "ES",
                "Sri Lanka": "LK",
                "Sudan": "SD",
                "Suriname": "SR",
                "Schweden": "SE",
                "Schweiz": "CH",
                "Syrien": "SY",
                "Tadschikistan": "TJ",
                "Taiwan": "TW",
                "Tokelau": "TK",
                "Tansania": "TZ",
                "Thailand": "TH",
                "Timor-Leste": "TL",
                "Togo": "TG",
                "Tonga": "TO",
                "Trinidad und Tobago": "TT",
                "Tristan da Cunha": "SH",
                "Tunesien": "TN",
                "Türkei": "TR",
                "Turks- und Caicosinseln": "TC",
                "Turkmenistan": "TM",
                "Tuvalu": "TV",
                "Uganda": "UG",
                "Amerikanische Überseeinseln": "UM",
                "Ukraine": "UA",
                "Vereinigte Arabische Emirate": "AE",
                "Vereinigtes Königreich": "GB",
                "Vereinigte Staaten": "US",
                "Uruguay": "UY",
                "Usbekistan": "UZ",
                "Vanuatu": "VU",
                "Venezuela": "VE",
                "Vietnam": "VN",
                "Britische Jungferninseln": "VG",
                "Wallis und Futuna": "WF",
                "Westsahara": "EH",
                "Jemen": "YE",
                "Sambia": "ZM",
                "Simbabwe": "ZW",
                "Afghanistan": "AF",
                "Albania": "AL",
                "Algeria": "DZ",
                "Andorra": "AD",
                "Angola": "AO",
                "Antigua and Barbuda": "AG",
                "Antigua-et-Barbuda": "AG",
                "Argentina": "AR",
                "Armenia": "AM",
                "Australia": "AU",
                "Austria": "AT",
                "Autriche": "AT", 
                "Azerbaijan": "AZ",
                "Azerbaïdjan": "AZ",
                "Bahamas": "BS",
                "Bahrain": "BH",
                "Bahreïn": "BH",
                "Bangladesh": "BD",
                "Barbados": "BB",
                "Barbados": "Barbade",
                "Belarus": "BY",
                "Biélorussie": "BY",
                "Belgium": "BE",
                "Belgique": "BE",
                "Belize": "BZ",
                "Benin": "BJ",
                "Bénin": "BJ",  
                "Bhutan": "BT",
                "Bolivia": "BO",
                "Bolivie": "BO", 
                "Bosnia and Herzegovina": "BA",
                "Bosnie-Herzégovine": "BA", 
                "Botswana": "BW",
                "Brazil": "BR",
                "Brunei": "BN",
                "Bulgaria": "BG",
                "Bulgarie": "BG", 
                "Burkina Faso": "BF",
                "Burundi": "BI",
                "Cabo Verde": "CV",
                "Cambodia": "KH",
                "Cambodge": "KH",
                "Cameroon": "CM",
                "Canada": "CA",
                "Central African Republic": "CF",
                "Chad": "TD",
                "Chile": "CL",
                "China": "CN",
                "Colombia": "CO",
                "Colombie": "CO",
                "Comoros": "KM",
                "Congo (Congo-Brazzaville)": "CG",
                "Costa Rica": "CR",
                "Croatia": "HR",
                "Croatie": "HR",
                "Cuba": "CU",
                "Cyprus": "CY",
                "Czech Republic": "CZ",
                "Democratic Republic of the Congo": "CD",
                "Denmark": "DK",
                "Danemark": "DK", 
                "Djibouti": "DJ",
                "Dominica": "DM",
                "Dominique": "DM",
                "Dominican Republic": "DO",
                "Ecuador": "Équateur",
                "Ecuador": "EC",
                "Egypt": "EG",
                "El Salvador": "SV",
                "Equatorial Guinea": "GQ",
                "Eritrea": "ER",
                "Érythrée": "ER", 
                "Estonia": "EE",
                "Eswatini": "SZ",
                "Ethiopia": "ET",
                "Éthiopie": "ET", 
                "Fiji": "FJ",
                "Fidji": "FJ", 
                "Finland": "FI",
                "Finlande": "FI", 
                "France": "FR",
                "Gabon": "GA",
                "Gambia": "GM",
                "Gambie": "GM", 
                "Georgia": "GE",
                "Germany": "DE",
                "Ghana": "GH",
                "Greece": "GR",
                "Grèce": "GR",
                "Grenada": "GD",
                "Grenade": "GD", 
                "Guatemala": "GT",
                "Guinea": "GN",
                "Guinea-Bissau": "GW",
                "Guyana": "GY",
                "Haiti": "HT",
                "Honduras": "HN",
                "Hungary": "HU",
                "Iceland": "IS",
                "Islande": "IS", 
                "India": "IN",
                "Indonesia": "ID",
                "Iran": "IR",
                "Iraq": "IQ",
                "Ireland": "IE",
                "Israel": "IL",
                "Israël": "IL",
                "Italy": "IT",
                "Jamaica": "JM",
                "Japan": "JP",
                "Jordan": "JO",
                "Kazakhstan": "KZ",
                "Kenya": "KE",
                "Kiribati": "KI",
                "Kuwait": "KW",
                "Kyrgyzstan": "KG",
                "Laos": "LA",
                "Latvia": "LV",
                "Lebanon": "LB",
                "Lesotho": "LS",
                "Liberia": "LR",
                "Libya": "LY",
                "Liechtenstein": "LI",
                "Lithuania": "LT",
                "Luxembourg": "LU",
                "Madagascar": "MG",
                "Malawi": "MW",
                "Malaysia": "MY",
                "Maldives": "MV",
                "Mali": "ML",
                "Malta": "MT",
                "Marshall Islands": "MH",
                "Mauritania": "MR",
                "Mauritius": "MU",
                "Mexico": "MX",
                "Micronesia": "FM",
                "Moldova": "MD",
                "Monaco": "MC",
                "Mongolia": "MN",
                "Montenegro": "ME",
                "Morocco": "MA",
                "Mozambique": "MZ",
                "Myanmar": "MM",
                "Namibia": "NA",
                "Nauru": "NR",
                "Nepal": "NP",
                "Netherlands": "NL",
                "New Zealand": "NZ",
                "Nicaragua": "NI",
                "Niger": "NE",
                "Nigeria": "NG",
                "North Korea": "KP",
                "North Macedonia": "MK",
                "Norway": "NO",
                "Oman": "OM",
                "Pakistan": "PK",
                "Palau": "PW",
                "Palestine State": "PS",
                "Panama": "PA",
                "Papua New Guinea": "PG",
                "Paraguay": "PY",
                "Peru": "PE",
                "Philippines": "PH",
                "Poland": "PL",
                "Portugal": "PT",
                "Qatar": "QA",
                "Romania": "RO",
                "Russia": "RU",
                "Rwanda": "RW",
                "Saint Kitts and Nevis": "KN",
                "Saint Lucia": "LC",
                "Saint Vincent and the Grenadines": "VC",
                "Samoa": "WS",
                "San Marino": "SM",
                "Sao Tome and Principe": "ST",
                "Saudi Arabia": "SA",
                "Arabie saoudite": "SA",
                "Senegal": "SN",
                "Serbia": "RS",
                "Seychelles": "SC",
                "Sierra Leone": "SL",
                "Singapore": "SG",
                "Slovakia": "SK",
                "Slovenia": "SI",
                "Solomon Islands": "SB",
                "Somalia": "SO",
                "South Africa": "ZA",
                "Afrique du Sud": "ZA", 
                "South Korea": "KR",
                "South Sudan": "SS",
                "Spain": "ES",
                "Espagne": "ES",
                "Sri Lanka": "LK",
                "Sudan": "SD",
                "Suriname": "SR",
                "Sweden": "SE",
                "Switzerland": "CH",
                "Syria": "SY",
                "Taiwan": "TW",
                "Tajikistan": "TJ",
                "Tanzania": "TZ",
                "Thailand": "TH",
                "Timor-Leste": "TL",
                "Togo": "TG",
                "Tonga": "TO",
                "Trinidad and Tobago": "TT",
                "Tunisia": "TN",
                "Turkey": "TR",
                "Turkmenistan": "TM",
                "Tuvalu": "TV",
                "Uganda": "UG",
                "Ukraine": "UA",
                "United Arab Emirates": "AE",
                "United Kingdom": "GB",
                "Uruguay": "UY",
                "Uzbekistan": "UZ",
                "Vanuatu": "VU",
                "Vatican City": "VA",
                "Venezuela": "VE",
                "Vietnam": "VN",
                "Yemen": "YE",
                "Zambia": "ZM",
                "Zimbabwe": "ZW",
                "Afganistán": "AF",
                "Albania": "AL",
                "Albanie": "AL",
                "Argelia": "DZ",
                "Andorra": "AD",
                "Angola": "AO",
                "Antigua y Barbuda": "AG",
                "Argentina": "AR",
                "Arménie": "AR",
                "Armenia": "AM",
                "Australia": "AU",
                "Australie": "AU", 
                "Austria": "AT",
                "Azerbaiyán": "AZ",
                "Las Bahamas": "BS",
                "Baréin": "BH",
                "Bangladés": "BD",
                "Barbados": "BB",
                "Barbade": "BB",
                "Bielorrusia": "BY",
                "Bélgica": "BE",
                "Belice": "BZ",
                "Benín": "BJ",
                "Bután": "BT",
                "Bolivia": "BO",
                "Bosnia y Herzegovina": "BA",
                "Botsuana": "BW",
                "Brasil": "BR",
                "Brunéi": "BN",
                "Bulgaria": "BG",
                "Burkina Faso": "BF",
                "Burundi": "BI",
                "Cabo Verde": "CV",
                "Camboya": "KH",
                "Camerún": "CM",
                "Canadá": "CA",
                "República Centroafricana": "CF",
                "Chad": "TD",
                "Chile": "CL",
                "China": "CN",
                "Colombia": "CO",
                "Comoras": "KM",
                "Congo (Brazzaville)": "CG",
                "Costa Rica": "CR",
                "Croacia": "HR",
                "Cuba": "CU",
                "Chipre": "CY",
                "República Checa": "CZ",
                "República Democrática del Congo": "CD",
                "Dinamarca": "DK",
                "Yibuti": "DJ",
                "Dominica": "DM",
                "República Dominicana": "DO",
                "Ecuador": "EC",
                "Egipto": "EG",
                "El Salvador": "SV",
                "Guinea Ecuatorial": "GQ",
                "Eritrea": "ER",
                "Estonia": "EE",
                "Estonie": "EE", 
                "Esuatini": "SZ",
                "Etiopía": "ET",
                "Fiyi": "FJ",
                "Finlandia": "FI",
                "Francia": "FR",
                "Gabón": "GA",
                "Gambia": "GM",
                "Georgia": "GE",
                "Alemania": "DE",
                "Ghana": "GH",
                "Grecia": "GR",
                "Granada": "GD",
                "Guatemala": "GT",
                "Guinea": "GN",
                "Guinea-Bisáu": "GW",
                "Guyana": "GY",
                "Haití": "HT",
                "Honduras": "HN",
                "Hungría": "HU",
                "Islandia": "IS",
                "India": "IN",
                "Indonesia": "ID",
                "Irán": "IR",
                "Irak": "IQ",
                "Irlanda": "IE",
                "Israel": "IL",
                "Italia": "IT",
                "Jamaica": "JM",
                "Japón": "JP",
                "Jordania": "JO",
                "Kazajistán": "KZ",
                "Kenia": "KE",
                "Kiribati": "KI",
                "Kuwait": "KW",
                "Kirguistán": "KG",
                "Laos": "LA",
                "Letonia": "LV",
                "Líbano": "LB",
                "Lesoto": "LS",
                "Liberia": "LR",
                "Libia": "LY",
                "Liechtenstein": "LI",
                "Lituania": "LT",
                "Luxemburgo": "LU",
                "Madagascar": "MG",
                "Malaui": "MW",
                "Malasia": "MY",
                "Maldivas": "MV",
                "Malí": "ML",
                "Malta": "MT",
                "Islas Marshall": "MH",
                "Mauritania": "MR",
                "Mauricio": "MU",
                "México": "MX",
                "Micronesia": "FM",
                "Moldavia": "MD",
                "Mónaco": "MC",
                "Mongolia": "MN",
                "Montenegro": "ME",
                "Marruecos": "MA",
                "Mozambique": "MZ",
                "Myanmar": "MM",
                "Namibia": "NA",
                "Nauru": "NR",
                "Nepal": "NP",
                "Países Bajos": "NL",
                "Nueva Zelanda": "NZ",
                "Nicaragua": "NI",
                "Níger": "NE",
                "Nigeria": "NG",
                "Corea del Norte": "KP",
                "Macedonia del Norte": "MK",
                "Noruega": "NO",
                "Omán": "OM",
                "Pakistán": "PK",
                "Palaos": "PW",
                "Estado de Palestina": "PS",
                "Panamá": "PA",
                "Papúa Nueva Guinea": "PG",
                "Paraguay": "PY",
                "Perú": "PE",
                "Filipinas": "PH",
                "Polonia": "PL",
                "Portugal": "PT",
                "Catar": "QA",
                "Rumania": "RO",
                "Rusia": "RU",
                "Ruanda": "RW",
                "San Cristóbal y Nieves": "KN",
                "Santa Lucía": "LC",
                "San Vicente y las Granadinas": "VC",
                "Samoa": "WS",
                "San Marino": "SM",
                "Santo Tomé y Príncipe": "ST",
                "Arabia Saudita": "SA",
                "Senegal": "SN",
                "Serbia": "RS",
                "Seychelles": "SC",
                "Sierra Leona": "SL",
                "Singapur": "SG",
                "Eslovaquia": "SK",
                "Eslovenia": "SI",
                "Islas Salomón": "SB",
                "Somalia": "SO",
                "Sudáfrica": "ZA",
                "Corea del Sur": "KR",
                "Sudán del Sur": "SS",
                "España": "ES",
                "Sri Lanka": "LK",
                "Sudán": "SD",
                "Surinam": "SR",
                "Suecia": "SE",
                "Suiza": "CH",
                "Siria": "SY",
                "Taiwán": "TW",
                "Tayikistán": "TJ",
                "Tanzania": "TZ",
                "Tailandia": "TH",
                "Timor Oriental": "TL",
                "Togo": "TG",
                "Tonga": "TO",
                "Trinidad y Tobago": "TT",
                "Túnez": "TN",
                "Turquía": "TR",
                "Turkmenistán": "TM",
                "Tuvalu": "TV",
                "Uganda": "UG",
                "Ucrania": "UA",
                "Emiratos Árabes Unidos": "AE",
                "Reino Unido": "GB",
                "United Kingdom": "GB",
                "Estados Unidos": "US",
                "Uruguay": "UY",
                "Uzbekistán": "UZ",
                "Vanuatu": "VU",
                "Ciudad del Vaticano": "VA",
                "Venezuela": "VE",
                "Vietnam": "VN",
                "Yemen": "YE",
                "Zambia": "ZM",
                "Zimbabue": "ZW",
                "Tanzania, United Republic Of": "TZ",
                "Hong Kong": "HK",
                "French Polynesia": "PF"
                
              };
      
              countrySelect.querySelectorAll('option').forEach(option => {
                const countryName = option.value;
                const countryCode = countryCodeMapping[countryName];
      
                if (countryCode) {
                  option.setAttribute('data-country-code', countryCode);
                  option.setAttribute('translate', 'no');
                }

              });
        }

        const selectCountry = this.countryEl;
        const selectedOptions = Array.from(selectCountry.options);
        const targetOption = selectedOptions.find(option => option.value === '---');
        if (targetOption) {
          selectCountry.removeChild(targetOption);
          selectCountry.insertBefore(targetOption, selectCountry.firstChild);
          targetOption.selected = true;
        }
      
      this.handleCountryChange();

      if (this.provinceEl.dataset.default && this.provinceEl.options.length > 0) {
        CountryProvinceSelector.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
      }

      this.countryEl.addEventListener('change', this.handleCountryChange.bind(this));
    }

    /**
     * Handles 'change' events on the country selector.
     */
    handleCountryChange() {
      const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
      const provinces = JSON.parse(selectedOption.dataset.provinces);

      if(this.querySelector('.billing_country').value == 'United Kingdom' || this.querySelector('.billing_country').value == 'Royaume-Uni'  || this.querySelector('.billing_country').value == 'Wielka Brytania' || this.querySelector('.billing_country').value == 'Vereinigtes Königreich'){
        this.querySelector('.billing_state').classList.add('hidden');
      }else{
        this.querySelector('.billing_state').classList.remove('hidden');
      }  
      
      // Remove current options.
      Array.from(this.provinceEl.options).forEach((option) => option.remove());

      if (provinces && provinces.length === 0) {
        this.provinceContainer.hidden = true;
      } else {
        provinces.forEach((province) => {
          const option = document.createElement('option');
          [option.value, option.innerHTML] = province;
          this.provinceEl.appendChild(option);
        });

        this.provinceContainer.hidden = false;
      }

      function updateIncludedRegionCode(billing_country) {
        const SelectedcountryCode = billing_country.options[billing_country.selectedIndex].dataset.countryCode;
        request.includedRegionCodes = [SelectedcountryCode];
      }
      
      updateIncludedRegionCode(billing_country);

      const mainContainer = this.closest(".main_container");
      const addressField = mainContainer.querySelector('.address_input');
      const apartmentField = mainContainer.querySelector('.apartment');
      const cityField = mainContainer.querySelector('.city');
      const zipcodeField = mainContainer.querySelector('.postalCode');
      const suggestions_container = mainContainer.querySelector('.suggestions_container');
      
      if (addressField) addressField.value = '';
      if (apartmentField) apartmentField.value = '';
      if (cityField) cityField.value = '';
      if (zipcodeField) zipcodeField.value = '';
      if (suggestions_container) suggestions_container.innerHTML = '';
      
    }

    /**
     * Sets the selected option of a <select> element.
     * @param {Element} selector - Country or province <select> element.
     * @param {string} value - Value of the option to select.
     */
    static setSelectedOption(selector, value) {
      Array.from(selector.options).forEach((option, index) => {
        if (option.value === value || option.innerHTML === value) {
          selector.selectedIndex = index;
        }
      });
    }
  }

  customElements.define('country-province-selector', CountryProvinceSelector);
}
